import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { AuthenticationState } from '../../store/authentication/types'
import { Profil } from '../../model/entities/profil'
import { trackPromise } from 'react-promise-tracker'
import { projetService } from '../../services/projet-service'
import { ProjetListItem } from '../../model/dto/projet-list-item'
import { publicService } from '../../services/public-service'
import { ProjetCreationWorkflow } from '../../model/entities/projet-creation-workflow'
import { ProfilCode, ProjetDetailResponse } from '../../model/dto/response'
import Projet from '../../model/projet'
import { ProjetListHeader } from './projet-list-header'
import { Card, Container, Modal } from 'semantic-ui-react'
import { PourBientotScreen } from '../generic/c-est-pour-bientot'
import { LoadingSpinner } from '../generic/loading-spinner'
import { ProjetLine } from './projet-line'
import { SubmitButton } from '../generic/submit-button'
import { CreateProjetWorkflowForm } from './forms/create-projet-workflow'

type Props = {

}

export function ProjetListNew({}: Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)

    const [projetList, setProjetList] = useState<ProjetListItem[]>([])
    const [error, setError] = useState("")
    const [creationStep, setCreationStep] = useState(ProjetCreationWorkflow.INFORMATIONS_GENERALES)
    const [isEdited, setIsEdited] = useState(false)
    const [newProjet, setNewProjet] = useState<Projet>()
    const [reload, setReload] = useState(true)

    useEffect(() => {
        if(reload) {
            if(loginProps?.oauth?.profilCode === Profil.PORTEUR_PROJET) {
                trackPromise(projetService.getProjetList(loginProps?.oauth)
                .then(data => {
                    if (data) {
                        setProjetList(data.ProjetList!)
                    }
                })
                .catch(ex => {
                    setError(ex)
                }));
            } else if(loginProps?.oauth?.profilCode === Profil.VILLYZ_USER) {
                trackPromise(projetService.getProjetAdmin(loginProps?.oauth)
                .then(data => {
                    if (data) {
                        setProjetList(data.ProjetList!)
                    }
                })
                .catch(ex => {
                    setError(ex)
                }));
            }
            else {
                trackPromise(publicService.getProjetList()
                .then(response => {
                    setProjetList(response.ProjetList!)
                })
                .catch(ex => {
                    setError(ex)
                }));
            }

            setReload(false)
        }
    }, [reload])

    const stepTitle = useMemo(() => {
        if(creationStep === ProjetCreationWorkflow.INFORMATIONS_GENERALES) {
            return "Informations générales"
        }
            
        if(creationStep === ProjetCreationWorkflow.DESCRIPTION) {
            return "Description du projet"
        }
            
        if(creationStep === ProjetCreationWorkflow.FINANCEMENT_GLOBAL) {
            return "Financement du projet"
        }

        if(creationStep === ProjetCreationWorkflow.FINANCEMENT_PARTICIPATIF) {
            return "Financement participatif"
        }

        if(creationStep === ProjetCreationWorkflow.CAGNOTTE) {
            return "Période de collecte"
        }

        if(creationStep === ProjetCreationWorkflow.FINALISATION) {
            return "Finalisation"
        }
            
       return ""
    }, [creationStep])

    const onNewProjetClick = (response: ProjetDetailResponse) => {
        setIsEdited(true)
        setNewProjet(response.Projet)
    }

    const updateStep = (stepKey: string) => {
        setCreationStep(stepKey)
    }

    return (
        (projetList.length === 0 && loginProps?.user?.ProfilCode == ProfilCode.INVESTISSEUR && (
            <>
                <ProjetListHeader />
                <Container
                    css={{
                        marginTop: "40px"
                    }}
                >
                    <LoadingSpinner >
                        <PourBientotScreen 
                        subtitle = "Nous aussi, nous attendons avec impatience les premiers projets de la plateforme !​​"
                        subtitle2 = "Le premier projet à financer arrivera dans quelques semaines." 
                        />
                    </LoadingSpinner>
                </Container>
            </>
        ) || (
            <>
                <ProjetListHeader />
                <Container
                    css={{
                        marginTop: "40px"
                    }}
                >
                    <LoadingSpinner>
                    {projetList.length > 0 ?
                    <Card.Group itemsPerRow={3} doubling stackable>
                    {projetList.map(projetItem => <ProjetLine key={projetItem.Id} projet={projetItem} isCardClickable={true} reload={()=> setReload(true)} />)}
                    </Card.Group>
                    : 
                        <PourBientotScreen title="Publiez votre 1er projet !"/>
                    }
                    </LoadingSpinner>

                    <div css={{margin: "20px 0"}}>
                        {loginProps && loginProps.oauth?.profilCode === ProfilCode.PORTEUR_PROJET && (
                        <div css={{textAlign : "center"}}>
                            <SubmitButton 
                                label="Créer un nouveau projet"
                                action={() => projetService.createProjet(loginProps?.oauth)}
                                onActionSuccess={onNewProjetClick}
                                
                            />
                            <Modal closeOnDocumentClick={false} css={{overflowX: "hidden"}} onClose={() => setIsEdited(false)} open={isEdited}>
                                <Modal.Header>{stepTitle}</Modal.Header>
                                <Modal.Content>
                                <Modal.Description>
                                    <CreateProjetWorkflowForm
                                        projet={newProjet!}
                                        onNextStep={updateStep}
                                    />
                                </Modal.Description>
                                </Modal.Content>
                            </Modal>
                        </div>
                        )}
                    </div>
                </Container>
            </>
        ))
    )
}